export const FETCH_ALLSECTIONS_REQUEST = 'FETCH_ALLSECTIONS_REQUEST'
export const FETCH_ALLSECTIONS_SUCCESS = 'FETCH_ALLSECTIONS_SUCCESS'
export const FETCH_ALLSECTIONS_FALIURE = 'FETCH_ALLSECTIONS_FALIURE'
